import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component<UploadCsvErrorRecord>({})
export default class UploadCsvErrorRecord extends Vue {
  @Prop({ default: {} })
  protected value!: ErrorRecordInterface;

  @Prop({ default: 0 })
  protected index!: number;

  protected showDetails = false;

  protected get diffEntries(): null | [string, ErrorRecordDiffItemInterface][] {
    if (!this.value || !this.value.diff) { return null; }

    return Object.entries(this.value.diff);
  }
}

export interface ErrorRecordDiffItemInterface {
  existing?: string;
  new?: string;
}

export type ErrorRecordDiffType = Record<string, ErrorRecordDiffItemInterface>;

export interface ErrorRecordInterface {
  diff?: ErrorRecordDiffType;
  existing?: string;
  text?: string;
}
